import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css'; // we'll re-add later
import App from './App.jsx';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
